<template>
  <div>
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-image"></i>
                  <h2 class="card-big-info-title">Banner</h2>
                  <p class="card-big-info-desc">Ažurirajte detalje bannera.</p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.title.$anyError }"
                  >
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      Naziv
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="title"
                      />
                      <form-error
                        :model="$v.title"
                        :dirty="$v.$dirty"
                        label="Naziv"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      Tekst
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        class="form-control form-control-modern"
                        placeholder="Tekst bannera"
                        v-model="bannerText"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      Pozicija
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="bannerType"
                      >
                        <option
                          v-for="item in bannerTypeOptions"
                          :value="item.id"
                          :key="item.id"
                        >
                          {{ item.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      Poravnanje teksta
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="bannerTextAlignment"
                      >
                        <option value="left">Lijevo</option>
                        <option value="center">Centar</option>
                        <option value="right">Desno</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      Vidljivo na naslovnoj?
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          id="visible-on-main-page"
                          type="checkbox"
                          v-model="visibleOnMainPage"
                        />
                        <label class="control-label" for="visible-on-main-page"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Slika</label>
                    <div class="col-lg-7 col-xl-6">
                      <img
                        v-if="imageUrl && !newImageBase64"
                        :src="`${baseUrl}${imageUrl}`"
                        class="mb-2"
                        style="max-width: 240px; display: block"
                      />
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="photo"
                        accept="image/*"
                        @change="handlePhotoUpload"
                      />
                      <span class="form-text">
                        Preporučena rezolucija 855px x 480px
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <button
            type="button"
            class="btn btn-danger btn-px-4 py-3 me-auto font-weight-semibold text-3"
            @click.prevent="deleteBanner"
          >
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
          <router-link
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
            exact
            :to="{ name: 'Banners' }"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { translations } from "@/mixins";
import api from "@/services/api";
import config from "@/config";
import FormError from "../../shared/form-errors/FormError.vue";

export default {
  name: "EditBanner",
  mixins: [translations],
  components: { FormError },
  validations: {
    title: { required },
  },
  data() {
    return {
      id: null,
      title: "",
      bannerText: "",
      bannerType: 3,
      bannerTextAlignment: "left",
      bannerTextBackground: "",
      visibleOnMainPage: true,
      imageUrl: "",
      newImageBase64: "",
      bannerTypeOptions: [
        { id: 1, text: "Kategorije" },
        { id: 2, text: "Lijeva strana" },
        { id: 3, text: "Desna strana (editorial)" },
      ],
    };
  },
  computed: {
    banner() {
      return this.$store.getters.getBanner;
    },
    baseUrl() {
      return config.baseUrl;
    },
  },
  watch: {
    banner: {
      immediate: true,
      handler(b) {
        if (!b || !b.id) return;
        this.id = b.id;
        this.title = b.title || "";
        this.bannerText = b.bannerText || "";
        this.bannerType = b.bannerType || 3;
        this.bannerTextAlignment = b.bannerTextAlignment || "left";
        this.bannerTextBackground = b.bannerTextBackground || "";
        this.visibleOnMainPage = !!b.visibleOnMainPage;
        this.imageUrl = b.imageUrl || "";
      },
    },
  },
  mounted() {
    this.$store.dispatch("getBanner", this.$route.params.id);
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toast.error(this?.translations?.forms?.notValid);
        return;
      }

      const payload = {
        id: this.id,
        title: this.title,
        bannerText: this.bannerText,
        bannerType: this.bannerType,
        bannerTextAlignment: this.bannerTextAlignment,
        bannerTextBackground: this.bannerTextBackground,
        visibleOnMainPage: this.visibleOnMainPage,
        interestsAreasIds: [],
      };

      if (this.$refs.photo.files[0] && this.newImageBase64) {
        payload.image = {
          file: this.newImageBase64.split(",")[1],
          fileName: this.$refs.photo.files[0].name,
        };
      }

      api.updateBanner(this.id, payload).then((response) => {
        this.$toast.info(response.data.info);
        this.$router.push({ name: "Banners" });
      });
    },
    deleteBanner() {
      api.deleteBanner(this.id).then((response) => {
        this.$toast.info(response.data.info);
        this.$router.push({ name: "Banners" });
      });
    },
    handlePhotoUpload() {
      const file = this.$refs.photo.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        this.newImageBase64 = e.target.result;
      };
    },
  },
};
</script>
